<div class="ManipMultiply">
    <div class="block_image" [ngStyle]="{minHeight: minHeight}" (click)="showControlModal()" role="button">
        <ng-container *ngFor="let image of imageSources; index as ind">
            <kh-img [path]="image" [hidden]="!canShowImage(ind)"></kh-img>
        </ng-container>
    </div>
</div>
